// Central registry of Ivory Pulse product images.
// Every image rendered on the site should be imported from here so they can
// be swapped in one place without touching component code.

const BASE =
  "https://customer-assets.emergentagent.com/job_6c1d9420-3e8a-44f6-bae0-863941ad590b/artifacts";

// New cleaner finish product shots (product-only, uploaded by the user).
// Used in the Finish Selector cards with object-fit: contain.
const FINISH_BASE =
  "https://customer-assets.emergentagent.com/job_pulse-wearable/artifacts";

// --- Named exports (preferred) ---
export const logoImage = `${BASE}/tr49v6p3_IvoryPulse%20logo%20oficial.jpeg`;
// White transparent wordmark for use on dark surfaces (navbar).
export const logoWhiteTransparent =
  "https://customer-assets.emergentagent.com/job_781ac44e-f1b2-4c8a-a0f7-ea0f0f39bf9f/artifacts/4gxlr5d6_ivory_pulse_logo_white_transparent.svg";
// Hero full-section background — outdoor / lifestyle promo grid.
export const heroImage =
  "https://customer-assets.emergentagent.com/job_781ac44e-f1b2-4c8a-a0f7-ea0f0f39bf9f/artifacts/hwerpdcd_promo5.png";
// New product-only finish shots — transparent backgrounds, framed
// against a cinematic dark product stage in the FinishSelector.
export const blackFinishImage =
  "https://customer-assets.emergentagent.com/job_781ac44e-f1b2-4c8a-a0f7-ea0f0f39bf9f/artifacts/1d1va9ci_obsidian_no_bg2.png";
export const goldFinishImage =
  "https://customer-assets.emergentagent.com/job_781ac44e-f1b2-4c8a-a0f7-ea0f0f39bf9f/artifacts/4xo57o18_gold_no_bg.png";
export const chromeFinishImage =
  "https://customer-assets.emergentagent.com/job_781ac44e-f1b2-4c8a-a0f7-ea0f0f39bf9f/artifacts/v3stjd79_chrome._no_bg.png";
// Legacy promo shots — still useful if we want marketing-poster crops later.
export const blackPromoImage = `${BASE}/5vy18ur1_obsidianpromo.png`;
export const goldPromoImage = `${BASE}/6ky4wm4v_goldpromo.png`;
export const chromePromoImage = `${BASE}/73kws3xt_chromepromo.png`;
// Optional lifestyle shot (unused today — reserved for future sections).
export const lifestyleImage = heroImage;

// --- Legacy ASSETS map kept for existing imports ---
export const ASSETS = {
  logo: logoImage,
  heroTrio: heroImage,
  obsidian: blackFinishImage,
  gold: goldFinishImage,
  chrome: chromeFinishImage,
};

// --- Finish metadata ---
// objectPosition kept for any component that still uses the legacy promos.
// The new FINISH images are product-only so no crop is needed.
export const FINISHES = [
  {
    id: "obsidian_black",
    label: "Obsidian Black",
    tagline: "Sophisticated · Powerful · Timeless",
    material: "Anodised black aluminium · Matte finish",
    image: blackFinishImage,
    swatch: "#111111",
    ring: "#2a2a2a",
    bg: "#040406",
    haloInner: "rgba(255, 255, 255, 0.10)",
    haloOuter: "rgba(60, 60, 70, 0.22)",
    accent: "#e5e5e5",
    glow: "rgba(255, 255, 255, 0.10)",
    objectPosition: "50% 50%",
  },
  {
    id: "champagne_gold",
    label: "Champagne Gold",
    tagline: "Bold · Elegant · Iconic",
    material: "PVD champagne gold · Brushed",
    image: goldFinishImage,
    swatch: "#c7a962",
    ring: "#8b6f3a",
    bg: "#0a0703",
    haloInner: "rgba(232, 217, 176, 0.30)",
    haloOuter: "rgba(199, 169, 98, 0.18)",
    accent: "#e8d9b0",
    glow: "rgba(199, 169, 98, 0.28)",
    objectPosition: "50% 50%",
  },
  {
    id: "chrome_silver",
    label: "Chrome Silver",
    tagline: "Refined · Modern · Effortless",
    material: "Polished chrome · Mirror finish",
    image: chromeFinishImage,
    swatch: "#e8e8e8",
    ring: "#c8c8c8",
    bg: "#06080b",
    haloInner: "rgba(220, 230, 240, 0.22)",
    haloOuter: "rgba(140, 160, 180, 0.18)",
    accent: "#dde3ec",
    glow: "rgba(200, 215, 230, 0.22)",
    objectPosition: "50% 50%",
  },
];

// No launch date has been announced. Never substitute a guessed date.
export const LAUNCH_DATE_UTC = null;
